App.SmTagComponent = Em.Component.extend
  classNames: ['sm-tag']
  classNameBindings: ['checked']
  attributeBindings: ['style']

  checked: null
  label: null
  backgroundActive: null

  style: Ember.computed 'checked', 'backgroundActive', ->
    if @get('checked')
      new Ember.Handlebars.SafeString "background-color: #{@get('backgroundActive')}"
    else
      null

  click: ->
    @toggleProperty('checked')